import * as ActionType from '../constants/ActionType'

export const initialState = {
    'loaded': false,
    'cartProcessSuccess': false,
    'data': {
        'printshopPrintable': [],
        'userPrintable': []
    }
};

function cart(state = initialState, action) {
    switch (action.type) {
        case ActionType.REQUEST_CART:
            return {
                ...state,
            };
        case ActionType.RECEIVE_CART:
            return {
                ...state,
                loaded: true,
                data: action.payload
            };
        case ActionType.RECEIVE_PROCESS_CART:
            return {
                ...initialState,
                cartProcessSuccess: true,
            };
        case ActionType.END_PROCESS_CART:
            return {
                ...state,
                cartProcessSuccess: false,
            };
        default:
            return state
    }
}

export default cart


// WEBPACK FOOTER //
// ./src/js/reducers/cart.js